{
  "page": {
    "title": "งานที่ต้องทำและการแจ้งเตือน",
    "intro": "ทุกอย่างที่ร้านต้องทำหรือตรวจ เรื่องด่วนอยู่บนสุด กด \"เปิด\" เพื่อไปหน้าที่แก้ได้ทันที",
    "kind": "ประเภท",
    "status": "สถานะ",
    "mine": "เฉพาะของฉัน",
    "error": "โหลดรายการงานไม่ได้",
    "empty_open": "ตอนนี้ไม่มีงานค้าง",
    "empty_open_body": "งานใหม่จะขึ้นที่นี่เอง",
    "empty": "ไม่มีรายการ",
    "more": "ดูเพิ่ม"
  },
  "kind_tab": {
    "all": "ทั้งหมด",
    "alert": "ปัญหา",
    "task": "งาน",
    "info": "ออเดอร์ใหม่"
  },
  "status_tab": {
    "open": "ยังไม่เสร็จ",
    "done": "เสร็จแล้ว",
    "all": "ทั้งหมด"
  },
  "kind": {
    "alert": "ปัญหา",
    "task": "งาน",
    "info": "ข้อมูล"
  },
  "status": {
    "open": "ยังไม่ทำ",
    "in_progress": "กำลังทำ",
    "done": "เสร็จแล้ว",
    "dismissed": "ปิดแล้ว"
  },
  "item": {
    "times_other": "×{{count}}",
    "assigned_me": "ฉันรับผิดชอบ",
    "assigned_to": "ผู้รับผิดชอบ: {{name}}",
    "unassigned": "ยังไม่มีคนรับ",
    "overdue": "เลยกำหนดตั้งแต่",
    "due": "กำหนด",
    "me_name": "{{name}} (ฉัน)",
    "someone": "พนักงาน",
    "you": "คุณ"
  },
  "actions": {
    "open": "เปิด",
    "reopen": "ยังไม่เสร็จ",
    "done": "เสร็จแล้ว",
    "assign_to": "ใครรับผิดชอบ",
    "assign_me": "ฉันรับเอง",
    "show_detail": "รายละเอียดสำหรับ IT",
    "hide_detail": "ซ่อนรายละเอียด"
  },
  "toast": {
    "done": "ทำเครื่องหมายเสร็จแล้ว",
    "reopened": "กลับไปอยู่ในรายการงานแล้ว",
    "assigned": "ตอนนี้ {{name}} รับผิดชอบ",
    "unassigned": "ตอนนี้ไม่มีคนรับผิดชอบ"
  },
  "alerts": {
    "legend": "เมื่อมีงานใหม่",
    "sound": "ส่งเสียง",
    "desktop": "แจ้งเตือนบนเครื่องนี้",
    "desktop_blocked": "เบราว์เซอร์นี้ไม่อนุญาตการแจ้งเตือน"
  },
  "dlq": {
    "for_it": "สำหรับ IT (ไม่แสดงข้อมูลลูกค้า)",
    "service": "ส่วนของระบบ",
    "subject": "ชนิดการอัปเดต",
    "consumer": "ตัวประมวลผล",
    "count": "จำนวน",
    "error": "ข้อผิดพลาด (ย่อ)",
    "how_to_retry": "IT ส่งการอัปเดตอีกครั้งด้วยคำสั่งนี้ก็ได้:",
    "runbook": "คู่มือ: {{path}}",
    "retry": "ส่งอีกครั้ง (再送)",
    "retry_explain": "ส่งการอัปเดตชนิดนี้ที่ล้มเหลวทั้งหมดอีกครั้ง ถ้าสำเร็จ งานนี้จะปิดเอง ถ้าล้มเหลวอีกจะมีงานใหม่ขึ้นมา",
    "ask_manager": "ให้เจ้าของร้านหรือผู้จัดการกด “ส่งอีกครั้ง”",
    "command_title": "สำหรับ IT: คำสั่ง",
    "sent_again_one": "ส่งการอัปเดต {{count}} รายการอีกครั้งแล้ว",
    "sent_again_other": "ส่งการอัปเดต {{count}} รายการอีกครั้งแล้ว",
    "some_left_one": "ส่งการอัปเดต {{count}} รายการอีกครั้งไม่ได้ — ต้องให้ IT ดู",
    "some_left_other": "ส่งการอัปเดต {{count}} รายการอีกครั้งไม่ได้ — ต้องให้ IT ดู"
  },
  "types": {
    "order_new": "ออเดอร์ใหม่",
    "payment_confirm_pending": "โอนเงินรอยืนยัน",
    "bank_transfer_notice": "ลูกค้าแจ้งว่าโอนแล้ว",
    "payment_overdue": "เลยกำหนดชำระ",
    "oversell_conflict": "การ์ดขายซ้ำ",
    "dlq_message": "งานเบื้องหลังล้มเหลว",
    "low_stock": "สต็อกใกล้หมด",
    "taxfree_deadline": "免税: กำหนดตรวจศุลกากร",
    "taxfree_refund_due": "免税: ต้องคืนภาษี",
    "export_evidence_missing": "ขาดหลักฐานส่งออก",
    "payout_due": "ถึงกำหนดจ่ายผู้ฝากขาย",
    "search_inconsistent": "ค้นหาบนเว็บไม่ตรงล่าสุด",
    "search_dlq": "อัปเดตการค้นหาบนเว็บล้มเหลว",
    "search_lag": "การค้นหาบนเว็บอัปเดตช้า",
    "search_document_rejected": "สินค้าเข้าการค้นหาไม่ได้",
    "document_integrity_mismatch": "เอกสารที่เก็บไว้ถูกเปลี่ยน",
    "document_failed": "สร้างเอกสารไม่ได้",
    "notification_failed": "ส่งอีเมลไม่ได้",
    "webhook_failed": "ส่งข้อความแชตไม่ได้",
    "document_missing": "เอกสารหาย",
    "tax_alert": "แจ้งเรื่องภาษี",
    "consignment_alert": "แจ้งเรื่องฝากขาย",
    "security_alert": "แจ้งเรื่องความปลอดภัย",
    "staff_locked": "บัญชีพนักงานถูกล็อก",
    "dsar_overdue": "คำขอข้อมูลส่วนบุคคลล่าช้า",
    "queue_backlog": "งานค้างสะสม",
    "mail_setup_problem": "ตั้งค่าส่งอีเมลไม่ถูก",
    "storage_threshold": "พื้นที่เก็บใกล้เต็ม",
    "order_alert": "ออเดอร์ต้องตรวจ",
    "return_request": "คำขอคืนของ",
    "payment_alert": "แจ้งเรื่องการชำระเงิน",
    "refund_failed": "คืนเงินไม่สำเร็จ",
    "inventory_orphaned": "สต็อกที่ไม่มีสินค้า",
    "stock_discrepancy": "ตัวเลขสต็อกไม่ตรง",
    "website_refresh_failed": "เว็บอาจยังไม่อัปเดต",
    "manual": "พนักงานเขียนเอง",
    "pending_payment_digest": "รายการออเดอร์ค้างชำระรายวัน",
    "daily_summary": "สรุปรายวัน",
    "inbox_escalation": "งานด่วนยังค้าง"
  },
  "settings": {
    "title": "การแจ้งเตือน",
    "intro": "ใครได้รู้เรื่องอะไร ลูกค้าได้อีเมลอะไร และอีเมลที่ส่งออกไปแล้ว",
    "tab": {
      "people": "ผู้รับแจ้งเตือน",
      "emails": "อีเมลถึงลูกค้า",
      "sent": "อีเมลที่ส่งแล้ว"
    },
    "error": "โหลดการตั้งค่าการแจ้งเตือนไม่ได้",
    "read_only": "เฉพาะเจ้าของร้านแก้การตั้งค่านี้ได้ คุณดูได้อย่างเดียว",
    "saved": "บันทึกการตั้งค่าการแจ้งเตือนแล้ว",
    "conflict": "มีคนอื่นบันทึกก่อน แสดงข้อมูลล่าสุดแล้ว — แก้อีกครั้ง",
    "save": "บันทึก",
    "undo_changes": "ยกเลิกที่แก้"
  },
  "recipients": {
    "title": "ใครได้รับแจ้งเตือน",
    "intro": "งานทุกอย่างอยู่ในรายการงานเสมอ ตรงนี้เลือกว่าใครได้อีเมลหรือข้อความแชตด้วย",
    "everything": "ได้รับทุกเรื่อง",
    "how_default": "ช่องทาง (ทุกเรื่อง)",
    "for_type": "ได้เรื่อง \"{{type}}\" ด้วย",
    "how": "ช่องทาง",
    "remove_type": "ลบบรรทัดนี้",
    "add_type": "เพิ่มผู้รับเฉพาะเรื่อง…",
    "nobody": "ยังไม่มี",
    "remove": "เอา {{name}} ออก",
    "add_staff": "เพิ่มพนักงาน…",
    "add_email": "หรือพิมพ์อีเมล",
    "add": "เพิ่ม",
    "bad_email": "ไม่ใช่รูปแบบอีเมล",
    "always_inbox": "รายการงาน: เสมอ",
    "channel": {
      "email": "อีเมล",
      "webhook": "แชต (Discord)"
    }
  },
  "webhooks": {
    "title": "แชต (Discord)",
    "intro": "ส่งการแจ้งเตือนเข้าห้อง Discord ได้ด้วย ที่อยู่เก็บเป็นความลับ บันทึกแล้วจะไม่แสดงอีก",
    "none": "ยังไม่มีห้องแชต",
    "name": "ชื่อ",
    "url": "ที่อยู่จาก Discord",
    "url_replace": "ที่อยู่ใหม่ (เว้นว่าง = ใช้ของเดิม)",
    "enabled": "เปิด",
    "all_alerts": "ทุกเรื่อง",
    "some_alerts_other": "{{count}} เรื่อง",
    "test": "ส่งทดสอบ",
    "remove": "ลบ",
    "add": "เพิ่มห้องแชต",
    "test_sent": "ส่งข้อความทดสอบแล้ว",
    "test_failed": "แชตไม่รับข้อความทดสอบ ตรวจที่อยู่อีกครั้ง"
  },
  "sender": {
    "title": "ผู้ส่งอีเมลของร้าน",
    "name": "ชื่อผู้ส่ง ({{language}})",
    "address": "อีเมลผู้ส่ง",
    "reply_to": "ตอบกลับไปที่",
    "empty_uses_default": "ช่องว่างจะใช้ค่าสีเทาที่แสดง"
  },
  "times": {
    "title": "เวลา",
    "digest": "ส่งรายการออเดอร์ค้างชำระเวลา",
    "daily_summary": "ส่งสรุปรายวันเวลา",
    "low_stock": "ถือว่าใกล้หมดเมื่อเหลือเท่านี้หรือน้อยกว่า"
  },
  "problems": {
    "from_address": "อีเมลผู้ส่งไม่ใช่รูปแบบอีเมล",
    "reply_to": "อีเมลตอบกลับไม่ใช่รูปแบบอีเมล",
    "digest_time": "ใส่เวลาเป็น ชั่วโมง:นาที",
    "daily_summary_time": "ใส่เวลาสรุปเป็น ชั่วโมง:นาที",
    "low_stock": "สต็อกใกล้หมด: ใส่เป็นจำนวนเต็ม",
    "webhook_url": "ห้องแชตใหม่ต้องมีที่อยู่ https:// จาก Discord",
    "webhook_name": "ห้องแชตต้องมีชื่อ"
  },
  "lang": {
    "en": "English",
    "ja": "日本語",
    "th": "ไทย",
    "zh-Hant": "繁體中文",
    "zh-Hans": "简体中文"
  },
  "emails": {
    "intro": "อีเมลที่ลูกค้าได้รับ พร้อมข้อมูลตัวอย่าง ข้อความแก้โดยทีมระบบ — หน้านี้แสดงอย่างเดียว",
    "which": "อีเมล",
    "off": "ปิดอยู่",
    "language": "ภาษา",
    "send_test": "ส่งทดสอบถึงฉัน ({{email}})",
    "error": "โหลดอีเมลไม่ได้",
    "preview_error": "แสดงอีเมลนี้ไม่ได้",
    "subject": "หัวเรื่อง",
    "fallback": "ยังไม่มีภาษานี้ — ลูกค้าจะได้ฉบับ{{language}}",
    "frame_title": "อีเมล: {{subject}}",
    "show_text": "แสดงฉบับข้อความล้วน",
    "hide_text": "ซ่อนฉบับข้อความล้วน",
    "test_sent": "ส่งอีเมลทดสอบถึง {{email}} แล้ว"
  },
  "sent": {
    "failed_only": "เฉพาะที่ส่งไม่สำเร็จ",
    "error": "โหลดอีเมลที่ส่งแล้วไม่ได้",
    "empty": "ไม่มีอีเมล",
    "hidden": "ซ่อน",
    "open": "เปิด",
    "one_title": "อีเมล",
    "resend": "ส่งอีกครั้ง",
    "resent": "จะส่งอีเมลอีกครั้ง",
    "to": "ถึง",
    "state": "สถานะ",
    "when": "เวลา",
    "problem": "ปัญหา",
    "body_hidden": "เนื้อหาเห็นได้เฉพาะพนักงานที่ดูข้อมูลลูกค้าได้",
    "body_gone": "ไม่ได้เก็บสำเนาอีเมลนี้แล้ว",
    "status": {
      "queued": "รอส่ง",
      "sending": "กำลังส่ง",
      "sent": "ส่งแล้ว",
      "failed": "ไม่สำเร็จ",
      "suppressed": "ไม่ส่ง (ส่งถึงอีเมลนี้ไม่ได้)",
      "bounced": "ตีกลับ",
      "skipped": "ไม่ส่ง (ลูกค้าปิดไว้)"
    },
    "error_code": {
      "other": "เซิร์ฟเวอร์อีเมลไม่รับ"
    }
  }
}
